import React, { useEffect, useImperativeHandle, useRef, useState } from "react";
import { RADIO_FIELD_HIGHLIGHT_DEFAULT_DURATION} from "./constants";
import DataStore from "@shared/services/DataStore";

const RadioField = React.forwardRef(
    (
        {
            label,
            options,
            value,
            onChangeInput,
            errorMsg,
            containerClass,
            onFocusHighlightDuration = RADIO_FIELD_HIGHLIGHT_DEFAULT_DURATION,
            customOption=false,
            customButton=null,
            ...restProps
        },
        ref
    ) => {
        const containerRef = useRef(null);
        const clearHighlightTimerRef = useRef(null);
        const [highlighted, setHighlighted] = useState(false);

        useEffect(() => {
            if (value !== "" && typeof value !== "object" && options.find(opt => value == opt.value)) {
                let newVal = getValueObj(value);
                onChangeInput(newVal, false); //selecting the value that was set before options were populated
            }
        }, [value]);

        const getValueObj = _value => options.find(v => v.value == _value);

        const handleRadioChange = e => {
            let newVal = e.target.value;
            if (newVal === "true") newVal = true;
            if (newVal === "false") newVal = false;
            let valObj = getValueObj(newVal);
            onChangeInput(valObj);
        };

        const handleFocus = () => {
            clearTimeout(clearHighlightTimerRef.current);
            setHighlighted(true);
            clearHighlightTimerRef.current = setTimeout(() => {
                setHighlighted(false);
            }, onFocusHighlightDuration);
        };

        useImperativeHandle(ref, () => ({
            //different from traditional "focus", it highlights and scrolls the component
            focus: () => {
                containerRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
                handleFocus();
            }
        }));
        const STATIC_CDN_URL = DataStore.getData()?.cdnUrl || "https://cdnd1-kwt.amxremit.com/dev-1/static";
        const FALLBACK_COUNTRY_ICON_URL = `${STATIC_CDN_URL}/owa-content/currency/world-map.png`;

        return (
            <div
                ref={containerRef}
                className={`input-field-sec radio-group ${errorMsg ? "error-field" : ""} ${containerClass || ""} ${
                    highlighted ? "highlighted-radio" : ""
                }`}
            >
                {options.map((option, i) => (
                    <div className="aling-btn" key={i}>
                        <input
                            ref={ref}
                            type="radio"
                            id={option.label}
                            className="Custom-BeneCheckbox"
                            value={option.value}
                            checked={value.value == option.value}
                            onChange={handleRadioChange}
                            {...restProps}
                        />
                        {!customOption?
                        <label className={`${value.value == option.value ? "checked" : ""}`} htmlFor={option.label}>
                            <span>{option.label}</span>
                        </label>
                        :
                        <label className={`bene-option ${value.value == option.value ? "selected" : ""}`} htmlFor={option.label}>
                            <span className="bene-option-icon">
                                <img
                                    src={`${STATIC_CDN_URL}/owa-content/icons/${option?.data?.code}.png`}
                                    alt="icon"
                                    className="bene-option-icon-img"
                                    onError={e => {
                                        e.currentTarget.onerror = null;
                                        e.currentTarget.src = FALLBACK_COUNTRY_ICON_URL;
                                    }}
                                />
                            </span>
                            {option.label=="UPI PAYMENT" ?
                                <span className="bene-option-text upi-img-container">
                                                -
                                    <img src={require(`@app/stylesV2/images/SVG/google-pay.svg`)} alt="icon" />
                                    <img src={require(`@app/stylesV2/images/SVG/phone-pay.svg`)} alt="icon" />
                                    <img src={require(`@app/stylesV2/images/SVG/pay-tm.svg`)} alt="icon" />
                                </span>
                                :
                                <span className="bene-option-text">{option.label}</span>
                            }
                            {option.label=="VISA DIRECT" &&
                                <img
                                    src={require(`@app/stylesV2/images/SVG/italic-info${value.value == option.value ? "" : "-not"}-selected.svg`)}
                                    alt="icon"
                                    className="italic-info-white"
                                    onClick={(e) => {
                                        e.preventDefault(); // prevents triggering the radio selection
                                        e.stopPropagation(); // stops event bubbling
                                        customButton(option); // call your custom logic
                                    }}
                                />
                            }
                        </label>
                        }
                    </div>
                ))}
                {errorMsg && <span className="helperTextError">{errorMsg}</span>}
            </div>
        );
    }
);

export default RadioField;
